import { Component } from '@angular/core';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SubscribersService } from '@app/_services';
import { SiteService } from '@app/_services/site.service';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-footer-newsletter',
    templateUrl: './newsletter.component.html',
    styleUrls: ['./newsletter.component.scss'],
    standalone: true,
    imports: [NgIf, FormsModule, ReactiveFormsModule, TranslateModule]
})
export class NewsletterComponent {

    activeSocial = false;

    constructor(private subscribersService: SubscribersService,
        private toastr: ToastrService,
        public siteService: SiteService) {
        _.forEach(siteService.siteSetting?.socialMedia, socialMedia => {
            if (socialMedia.active) {
                this.activeSocial = true;
                return false;
            }
        });

    }
    email = new UntypedFormControl('', [Validators.email, Validators.required]);

    subscribe() {
        if (this.email.errors?.required) {
            this.toastr.error("Email required");
            return;
        }

        if (this.email.errors?.email) {
            this.toastr.error("Enter valid email");
            return;
        }
        let params = {
            email: this.email.value
        }

        this.subscribersService.addSubscriber(params).subscribe((response: any) => {
            if (response.code == 200) {
                this.toastr.success(response.msg);
            }

            if (response.code == 400) {
                this.toastr.error(response.msg);
            }
        })
    }
}
